export default {
  overcapGain: '由于达到上限，收入减少至 {0}%',
  overcapNoGain: '由于超果上限没有收入',
  benefitLoss: '购买这个会导致利益损失',
  gainTimerNeeded: '距离可以负担得起还有 {0}',
  capTimerNeeded: '距离达到容量上限还有 {0}',
  overcapTimerNeeded: '距离达到下一个容量等级还有 {0}',

  // Premium currencies
  gem_ruby: {
    name: '红宝石',
    description: '闪亮的红色宝石，可以兑换强大的永久升级'
  },
  gem_emerald: {
    name: '翡翠',
    description: '一种暗绿色的宝石，可用于购买各种改进品。 你的村民似乎喜欢它'
  },
  gem_sapphire: {
    name: '蓝宝石',
    description: '深蓝色宝石，可用于购买消耗品，帮助你更快进步'
  },
  gem_amethyst: {
    name: '紫水晶',
    description: '这种美丽的紫色宝石可用于购买主题或其他化妆品'
  },
  gem_topaz: {
    name: '黄玉',
    description: '黄色宝石，可用于提高你的表现或参加活动。 在大型活动期间，黄玉无法从宝石生成器中获得。 您将收到一种特定于活动的货币'
  },
  gem_diamond: {
    name: '钻石',
    description: ''
  },
  gem_onyx: {
    name: '玛瑙',
    description: ''
  },

  // Event currencies
  event_wax: {
    name: '蜡',
    description: '用于制作蜡烛的天然蜡'
  },
  event_humus: {
    name: '腐殖质',
    description: '你的花喜欢这新鲜肥沃的土壤'
  },
  event_cloud: {
    name: '云',
    description: '瓶子里捕捉到的一朵小云'
  },
  event_cocktail: {
    name: '混合物',
    description: '您很想自己喝这些，但它们对您的建造者来说是一个极好的动力源泉'
  },
  event_magic: {
    name: '魔法',
    description: '魔法会慢慢消耗，将你的其他货币转换成魔法货币。 你拥有的魔法越多，转换过程就越快。 神奇货币可以通过其不寻常的图标来识别。 要将它们恢复到常规版本，只需将鼠标悬停在它们上方，您就会获得成分作为回报'
  },
  event_snowball: {
    name: '雪球',
    description: '抓住!'
  },
  event_cindersToken: {
    name: '煤渣代币',
    description: '获得一定数量的光的奖励'
  },
  event_bloomToken: {
    name: '绽放代币',
    description: '达到花卉类型新等级记录的奖励'
  },
  event_weatherChaosToken: {
    name: '天气混乱代币',
    description: '达到鱼类新尺寸记录的奖励'
  },
  event_summerFestivalToken: {
    name: '夏季节日代币',
    description: '完成任务的奖励'
  },
  event_nightHuntToken: {
    name: '夜间狩猎代币',
    description: '升级药水或成功完成新仪式的奖励'
  },
  event_snowdownToken: {
    name: '降雪代币',
    description: '打雪仗获胜的奖励'
  },
  event_light: {
    name: '光',
    description: '燃烧得更亮'
  },
  event_soot: {
    name: '煤烟',
    description: '燃烧的蜡烛留下的'
  },
  event_blossom: {
    name: '开花',
    description: '她们很漂亮，但看起来都一样'
  },
  event_algae: {
    name: '海藻',
    description: '绿色且粘稠'
  },
  event_driftwood: {
    name: '浮木',
    description: '你不知道它从哪里来，但它看起来仍然有用'
  },
  event_plastic: {
    name: '塑料',
    description: '为什么海里有这么多垃圾？'
  },
  event_slime: {
    name: '粘液',
    description: '你以为藻类是粘糊糊的'
  },
  event_log: {
    name: '木头',
    description: '一种基本建筑材料'
  },
  event_stoneBlock: {
    name: '石块',
    description: '从山上切下来的'
  },
  event_coconut: {
    name: '椰子',
    description: '很难破开'
  },
  event_shell: {
    name: '贝壳',
    description: '你在海滩上发现的贝壳'
  },
  event_music: {
    name: '音乐',
    description: '你管这叫音乐?'
  },
  event_sand: {
    name: '沙子',
    description: '沙子，一望无际'
  },
  event_freshWater: {
    name: '淡水',
    description: '新鲜并经过过滤'
  },
  event_coal: {
    name: '煤',
    description: '经常用来生火烹饪食物的资源'
  },
  event_metalPart: {
    name: '金属零件',
    description: '有人说是垃圾，有人说是宝藏'
  },
  event_pearl: {
    name: '珍珠',
    description: '在贝壳中发现的稀有珍珠'
  },
  event_salt: {
    name: '盐',
    description: '咸的?'
  },
  event_pepper: {
    name: '胡椒',
    description: '当你需要一些香料时完美'
  },
  event_honey: {
    name: '蜂蜜',
    description: '多么甜啊'
  },
  event_vegetable: {
    name: '蔬菜',
    description: '营养丰富且可能美味'
  },
  event_citrusFruit: {
    name: '柑橘类水果',
    description: '酸甜可口'
  },
  event_rawFish: {
    name: '生鱼',
    description: '刚从海洋里捕捞上来'
  },
  event_cookedFish: {
    name: '熟鱼',
    description: '配上一些柠檬会很棒'
  },
  event_rawMeat: {
    name: '生肉',
    description: '刚从森林里出来的'
  },
  event_cookedMeat: {
    name: '熟肉',
    description: '只需要一些盐和胡椒粉'
  },
  event_solidPlate: {
    name: '实心板',
    description: '常见的建筑材料由木材和石头制成'
  },
  event_sandstone: {
    name: '砂岩',
    description: '看起来像沙子，但行为却像石头'
  },
  event_hardSteel: {
    name: '硬钢',
    description: '不锈钢，甚至比普通钢更硬'
  },
  event_compositePlate: {
    name: '复合板',
    description: '您决定将所有内容合并在一起，并且它...有效！'
  },
  event_coconutSalad: {
    name: '椰子沙拉',
    description: '清新又简单'
  },
  event_saltyShell: {
    name: '咸贝壳',
    description: '这是……后天习得的品味'
  },
  event_lemonCandy: {
    name: '柠檬糖',
    description: '孩子们喜欢这些'
  },
  event_steak: {
    name: '牛扒',
    description: '完全煮熟'
  },
  event_fishSticks: {
    name: '鱼条',
    description: '永恒的经典'
  },
  event_essence: {
    name: '精华',
    description: '一种奇怪的液体，但看起来很强大'
  },
  event_lavender: {
    name: '薰衣草',
    description: '在森林里发现的'
  },
  event_mapleLeaf: {
    name: '枫叶',
    description: '奇怪，看不到枫树'
  },
  event_fourLeafClover: {
    name: '四叶草',
    description: '幸运!'
  },
  event_charredSkull: {
    name: '烧焦的头骨',
    description: '这些骨头不仅被烧焦，而且看上去也极其古老'
  },
  event_mysticalWater: {
    name: '神秘的水',
    description: '看起来和普通水一样，但颜色更亮一些'
  },
  event_cheese: {
    name: '奶酪',
    description: '大多数人都会吃这个，但它还有很大的神奇用途'
  },
  event_spiderWeb: {
    name: '蜘蛛网',
    description: '里面没有蜘蛛，看起来是你的了'
  },
  event_strangeEgg: {
    name: '奇怪的蛋',
    description: '这是什么？这可能属于什么生物？好吧，你去混进去!'
  },
  event_puzzlePiece: {
    name: '一块拼图',
    description: '它可以解决逻辑难题，但也可以解决魔法难题?'
  },
  event_wizardHat: {
    name: '巫师帽',
    description: '看起来很花哨!'
  },
  event_cactus: {
    name: '仙人掌',
    description: '别碰它'
  },
  event_feather: {
    name: '羽毛',
    description: '不是重量级的'
  },
  event_dough: {
    name: '面团',
    description: '当你可以吃面团时为什么要吃饼干?'
  },
  event_cinnamon: {
    name: '肉桂',
    description: '没有肉桂的冬天会怎样?'
  },
  event_sapling: {
    name: '树苗',
    description: '松树树苗。 如果有足够的时间，它们可以长成参天大树'
  },
  event_water: {
    name: '水',
    description: '干净、冷的自来水'
  },
  event_snow: {
    name: '雪',
    description: '天气很冷，到处都是，只要有足够的量，你就可以堆一个完整的雪人'
  },
  event_yarn: {
    name: '纱',
    description: '让每个人都温暖舒适'
  },

  // Feature currencies
  mining_scrap: {
    name: '废料',
    description: '不知道为什么，地下岩石里充满了废料！ 但这也可能是一件好事，废料用途广泛，几乎可以用来创造任何东西'
  },
  mining_oreAluminium: {
    name: '铝矿石',
    description: '最后，有些东西不是废料。 在其未完善的形式中，它的用途是有限的，但这并不意味着无用'
  },
  mining_oreCopper: {
    name: '铜矿石',
    description: '另一种失踪的矿石。 这一项似乎比前一项产生了更好的结果。 下面还有多少？'
  },
  mining_oreTin: {
    name: '锡矿石',
    description: '轻质材料对于这些深处的黑暗来说是一种受欢迎的改变。 表面的洞越来越难以看见'
  },
  mining_oreIron: {
    name: '铁矿石',
    description: '一种坚硬而坚固的材料。 您发现的部分废料看起来与此类似'
  },
  mining_oreTitanium: {
    name: '钛矿石',
    description: '与铁相比，这似乎是坚不可摧的。 这可能有助于建造一些其他矿石不够稳定的东西'
  },
  mining_orePlatinum: {
    name: '铂矿石',
    description: '这种矿石如果稍微打磨一下，就会显得非常漂亮。 希望它不仅美观，而且实用'
  },
  mining_oreIridium: {
    name: '铱矿石',
    description: 'Irid……什么？ 您以前从未听说过这个，它还能用来做什么吗？'
  },
  mining_oreOsmium: {
    name: '锇矿石',
    description: ''
  },
  mining_oreLead: {
    name: '铅矿石',
    description: ''
  },
  mining_granite: {
    name: '花岗岩',
    description: '从地下开采出来的巨大花岗岩块。 令人惊讶的是，里面没有任何废料'
  },
  mining_salt: {
    name: '盐',
    description: '这种盐不是用来吃的，味道很苦。 最好用它来熔炼你的矿石'
  },
  mining_coal: {
    name: '煤',
    description: '这种资源似乎很稀缺，开采完后你在附近就找不到像矿石一样的资源了'
  },
  mining_sulfur: {
    name: '硫',
    description: '明亮、黄色'
  },
  mining_niter: {
    name: '硝',
    description: '另一种稀有资源，这个也是有限的'
  },
  mining_obsidian: {
    name: '黑曜石',
    description: '美丽的紫色碎片，它们看起来很脆弱'
  },
  mining_deeprock: {
    name: '深岩',
    description: ''
  },
  mining_glowshard: {
    name: '辉光碎片',
    description: ''
  },
  mining_barAluminium: {
    name: '铝锭',
    description: '许多中的第一个'
  },
  mining_barBronze: {
    name: '青铜锭',
    description: '大于其各部分之和'
  },
  mining_barSteel: {
    name: '钢锭',
    description: '强化的铁'
  },
  mining_barTitanium: {
    name: '钛锭',
    description: '极其耐用且耐腐蚀'
  },
  mining_barShiny: {
    name: '闪亮的金属锭',
    description: '这个不是很锋利也不耐用，但似乎还有其他用途'
  },
  mining_barIridium: {
    name: '铱锭',
    description: '这家伙到底有什么奇怪的属性……'
  },
  mining_barDarkIron: {
    name: '黑铁锭',
    description: ''
  },
  mining_ember: {
    name: '余烬',
    description: '小心，天气还很热！'
  },
  mining_resin: {
    name: '树脂',
    description: '用于使镐使用寿命更长的粘性树脂'
  },
  mining_crystalGreen: {
    name: '绿水晶',
    description: '这些水晶看起来很神奇！如果没有你的深度居民，你永远不会找到它们'
  },
  mining_smoke: {
    name: '烟雾',
    description: '这里呼吸越来越困难，这烟比普通烟更重'
  },
  mining_helium: {
    name: '氦',
    description: '也称为现实生活变声器'
  },
  mining_neon: {
    name: '氖',
    description: '一切看起来都是那么明亮...'
  },
  mining_argon: {
    name: '氩',
    description: ''
  },
  mining_krypton: {
    name: '氪',
    description: ''
  },
  mining_xenon: {
    name: '氙',
    description: ''
  },
  mining_radon: {
    name: '氡',
    description: ''
  },
  mining_crystalYellow: {
    name: '黄水晶',
    description: '这些晶体看起来也很棒！ 幸好你已经有了你的深度居民'
  },
  village_coin: {
    name: '金币',
    description: '通过向村民出售食物赚取金币'
  },
  village_copperCoin: {
    name: '铜币',
    description: '通过向村民出售手工制作的物品赚取的金币'
  },
  village_wood: {
    name: '木头',
    description: '从附近树木采伐的原木'
  },
  village_plantFiber: {
    name: '植物纤维',
    description: '草，小植物，树叶，都没关系。 它们都很有用'
  },
  village_stone: {
    name: '石头',
    description: '你的生物收集的小石头'
  },
  village_metal: {
    name: '金属',
    description: '你的生物通过挖掘地下发现了这种金属。 看来这个村庄的地下并没有充满废料'
  },
  village_gem: {
    name: '宝石',
    description: '这颗宝石珍贵而闪亮，是由专业矿工使用炸药发现的'
  },
  village_water: {
    name: '水',
    description: '只是简单的水'
  },
  village_vegetable: {
    name: '蔬菜',
    description: '当地村庄种植的新鲜蔬菜'
  },
  village_fruit: {
    name: '水果',
    description: '果实香甜多汁，深受村民喜爱'
  },
  village_fish: {
    name: '鱼',
    description: '这些鱼来自你村庄旁边的河里'
  },
  village_grain: {
    name: '粮食',
    description: '村里种植的植物的谷物。 你认为这个应该加工一下再吃，但村民不在乎'
  },
  village_knowledge: {
    name: '知识',
    description: '观察和学习'
  },
  village_science: {
    name: '科学',
    description: '通过在科学标准下进行实验，您可以收集数据，让您更好地了解这个世界'
  },
  village_joy: {
    name: '快乐',
    description: '通过达到超过 125% 的幸福值来获得快乐。 高于该值的更多快乐会产生更多快乐'
  },
  village_glass: {
    name: '玻璃',
    description: '小心点，别掉下来!'
  },
  village_faith: {
    name: '信仰',
    description: '你的村民确信未来情况会更好'
  },
  village_blessing: {
    name: '祝福',
    description: '村民们的希望终于成真了！ 未来一切都会更好！ 随着时间的推移，它会变得更容易！'
  },
  village_shares: {
    name: '股票',
    description: '投资是为了赚更多的钱!'
  },
  village_offering: {
    name: '供品',
    description: '需要牺牲资源的神秘产品'
  },
  village_hardwood: {
    name: '硬木',
    description: '这些原木是从需要几个世纪才能生长的巨树中获得的。 他们的木材很硬，但仍然有弹性'
  },
  village_oil: {
    name: '油',
    description: '灵活而宝贵的资源'
  },
  village_marble: {
    name: '大理石',
    description: '这块美丽的石头是更豪华建筑的常见选择'
  },
  village_meat: {
    name: '肉',
    description: '这些牛肯定过着美好的生活......对吧？'
  },
  village_loot0: {
    name: '常见战利品',
    description: '暂时必须做的事...'
  },
  village_loot1: {
    name: '罕见的战利品',
    description: '稍微好一点，但我们可以做得更多!'
  },
  village_loot2: {
    name: '稀有战利品',
    description: '终于有像样的东西了'
  },
  village_loot3: {
    name: '史诗战利品',
    description: '现在情况正在好转'
  },
  village_loot4: {
    name: '传说战利品',
    description: '传说!'
  },
  village_loot5: {
    name: '神话战利品',
    description: '你以为这些已经永远消失了'
  },
  village_acidVial: {
    name: '酸瓶',
    description: '小心!'
  },
  village_snowflake: {
    name: '雪花',
    description: ''
  },
  village_chiliBundle: {
    name: '辣椒包',
    description: ''
  },
  village_gears: {
    name: '齿轮',
    description: ''
  },
  horde_bone: {
    name: '骨头',
    description: '你杀死的敌人的骸骨'
  },
  horde_monsterPart: {
    name: '怪物零件',
    description: '当敌人停止出现时，可以在 10 区或更高区域找到令人厌恶的器官'
  },
  horde_corruptedFlesh: {
    name: '腐烂的肉体',
    description: '这看起来一点也不健康。 整块肉呈紫色，剧烈跳动'
  },
  horde_mysticalShard: {
    name: '神秘碎片',
    description: '充满未开发的力量'
  },
  horde_soulCorrupted: {
    name: '腐败的灵魂',
    description: '这些灵魂已经腐化，但并非所有希望都丧失了。 他们仍然可以通过复杂的仪式得救'
  },
  horde_soulEmpowered: {
    name: '强大的灵魂',
    description: '以前腐化的灵魂通过复杂的仪式得到净化和强化'
  },
  horde_courage: {
    name: '勇敢',
    description: '面对无尽的敌人，勇敢是一种非常需要的美德'
  },
  horde_crown: {
    name: '王冠',
    description: '他们曾经统治着塔楼，但现在已被废黜'
  },
  horde_towerKey: {
    name: '塔楼钥匙',
    description: '一把可以让你进入塔楼的稀有钥匙'
  },
  horde_blood: {
    name: '血液',
    description: '呕!'
  },
  horde_lockpick: {
    name: '撬锁器',
    description: '允许你从已经被击败的boss那里获得饰品。海盗专属'
  },
  farm_vegetable: {
    name: '蔬菜',
    description: '多吃蔬菜!'
  },
  farm_berry: {
    name: '浆果',
    description: '这个农场肥沃的土壤赋予了浆果浓郁的味道'
  },
  farm_grain: {
    name: '粮食',
    description: '将所有谷物存放在一个地方就可以了，只要让老鼠远离即可'
  },
  farm_flower: {
    name: '鲜花',
    description: '你可能会花上几个小时只是看着这些花'
  },
  farm_gold: {
    name: '黄金',
    description: '埋在土里的小金块'
  },
  farm_seedHull: {
    name: '种子壳',
    description: '植物的外壳空了，种子似乎不见了'
  },
  farm_grass: {
    name: '草',
    description: '这看起来不自然，草不应该长在庄稼上'
  },
  farm_petal: {
    name: '花瓣',
    description: '这些花瓣生长在所有花朵上，但您只收集最美丽的花朵'
  },
  farm_bug: {
    name: '虫子',
    description: '你的植物吸引了各种各样的虫子。 收集它们是困难的部分'
  },
  farm_butterfly: {
    name: '蝴蝶',
    description: '轻盈美丽，但难以捕捉'
  },
  farm_ladybug: {
    name: '瓢虫',
    description: '它们可能很小，但如果你幸运的话，你可以在更大的群体中找到它们'
  },
  farm_spider: {
    name: '蜘蛛',
    description: '这些生物可能看起来很可怕，但它们有助于控制其他昆虫'
  },
  farm_bee: {
    name: '蜜蜂',
    description: '蜜蜂是花园里常见的景象。 不要打扰它们，让它们采集花蜜即可'
  },
  farm_mysteryStone: {
    name: '神秘石',
    description: '这是什么？ 它有什么用途？'
  },
  farm_goldenPetal: {
    name: '金色花瓣',
    description: '这种极其罕见的花瓣只能在玫瑰上找到。 有传言说带有这些花瓣的玫瑰看起来比其他玫瑰颜色更深'
  },
  farm_smallSeed: {
    name: '小种子',
    description: ''
  },
  gallery_beauty: {
    name: '美丽',
    description: '你花的时间越多，这幅画就会变得越美丽'
  },
  gallery_converter: {
    name: '转换器',
    description: '创建新颜色或现有颜色'
  },
  gallery_inspiration: {
    name: '灵感',
    description: '无限可能'
  },
  gallery_package: {
    name: '包裹',
    description: '里面有什么？ 没人知道！ 就像一个小秘密'
  },
  gallery_red: {
    name: '红色油漆',
    description: '充满激情地绘画'
  },
  gallery_redDrum: {
    name: '红色鼓',
    description: '整个鼓充满了红色油漆'
  },
  gallery_orange: {
    name: '橙色油漆',
    description: '新色彩，新世界'
  },
  gallery_orangeDrum: {
    name: '橙色鼓',
    description: '这个鼓充满了橙色油漆'
  },
  gallery_yellow: {
    name: '黄色油漆',
    description: '获得关注的简单方法'
  },
  gallery_yellowDrum: {
    name: '黄色鼓',
    description: '这个鼓很容易看到'
  },
  gallery_green: {
    name: '绿色油漆',
    description: '看似有毒，其实不然'
  },
  gallery_greenDrum: {
    name: '绿色鼓',
    description: '就像核反应堆旁边的鼓一样'
  },
  gallery_blue: {
    name: '蓝色油漆',
    description: '如此平静，这将为你的绘画增色不少'
  },
  gallery_blueDrum: {
    name: '蓝色鼓',
    description: '和其他的一样，但它是蓝色的'
  },
  gallery_purple: {
    name: '紫色油漆',
    description: '神秘而未知'
  },
  gallery_purpleDrum: {
    name: '紫色鼓',
    description: ''
  },
  "gallery_deep-orange": {
    name: '橙红色油漆',
    description: '这个颜色看起来很新，但也很熟悉'
  },
  "gallery_deep-orangeDrum": {
    name: '橙红色鼓',
    description: ''
  },
  gallery_amber: {
    name: '金色油漆',
    description: ''
  },
  gallery_amberDrum: {
    name: '金色鼓',
    description: ''
  },
  "gallery_light-green": {
    name: '浅绿色油漆',
    description: ''
  },
  "gallery_light-greenDrum": {
    name: '浅绿色油鼓',
    description: ''
  },
  gallery_teal: {
    name: '青色油漆',
    description: ''
  },
  gallery_tealDrum: {
    name: '青色鼓',
    description: ''
  },
  "gallery_light-blue": {
    name: '浅蓝色油漆',
    description: ''
  },
  "gallery_light-blueDrum": {
    name: '浅蓝色鼓',
    description: ''
  },
  gallery_pink: {
    name: '粉红色油漆',
    description: ''
  },
  gallery_pinkDrum: {
    name: '粉红鼓',
    description: ''
  },
  gallery_motivation: {
    name: '动机',
    description: ''
  },
  gallery_mysteryShape: {
    name: '神秘形状',
    description: '这是什么形状?它看起来很奇怪，好像它不属于这个维度'
  },
  gallery_circle: {
    name: '圆形',
    description: ''
  },
  gallery_rectangle: {
    name: '矩形',
    description: ''
  },
  gallery_triangle: {
    name: '三角形',
    description: '小心，那些东西很危险'
  },
  gallery_star: {
    name: '星形',
    description: ''
  },
  gallery_ellipse: {
    name: '椭圆形',
    description: ''
  },
  gallery_heart: {
    name: '心形',
    description: '<3'
  },
  gallery_square: {
    name: '正方形',
    description: ''
  },
  gallery_octagon: {
    name: '八边形',
    description: ''
  },
  gallery_pentagon: {
    name: '五边形',
    description: '它是一个形状，不是一个建筑'
  },
  gallery_hexagon: {
    name: '六边形',
    description: ''
  },
  gallery_cash: {
    name: '现金',
    description: '轻松赚钱!'
  },
  school_book: {
    name: '书籍',
    description: '搬运这些重书很困难'
  },
  school_goldenDust: {
    name: '金尘',
    description: '它散发出一种奇怪的能量，仿佛可以改变时间本身'
  },
  school_examPass: {
    name: '考试通过',
    description: '奇怪的是，我们原来的学校不需要它们。 这里需要他们参加考试'
  },
  card_shinyDust: {
    name: '闪亮的灰尘',
    description: ''
  },
  treasure_fragment: {
    name: '碎片',
    description: '破碎的宝藏碎片'
  }
};
